import {
  IonAvatar,
  IonButton,
  IonHeader,
  IonIcon,
  IonImg,
  IonModal,
  IonRadio,
  IonRadioGroup,
  IonRow,
} from "@ionic/react";
import * as d3 from "d3";
import { arrowForward, checkmarkCircleOutline, close } from "ionicons/icons";
import ZoomSvg from "../../assets/svg/zoom.svg";

import { ReactSVG } from "react-svg";

import "./ReportDamageModal.css";

import { svgMapping, tractorMapping } from "../../data/vehicleMapping";
import { inspectionRouteMapping } from "../../data/InspectionRoute";
import { useEffect, useRef, useState } from "react";
import { VehiclePart } from "../../types/api/vehiclePart.types";
interface Step1Props {
  side: string;
  type: string;
  setStep: (step: number) => void;
  setSelectedElement: (element: string) => void;
  selectedElement: string;
  vehicleParts: VehiclePart[];
}

const Step1Documents: React.FC<Step1Props> = ({
  side,
  type,
  setStep,
  selectedElement,
  setSelectedElement,
  vehicleParts,
}) => {
  let currentSvg = svgMapping(side, type);

  return (
    <div>
      <IonRow className="ReportDamageModal-title">
        Indiquez le type de dommage
      </IonRow>
      <IonRow className="ion-justify-content-center">
        <IonButton
          color="warning"
          expand="block"
          className={
            !selectedElement
              ? "ReportDamageModal-button-hidden"
              : "ReportDamageModal-button"
          }
        >
          <IonIcon
            icon={checkmarkCircleOutline}
            color="primary"
            size=""
            className="PathCard-icon"
            slot="start"
          />
          {selectedElement
            ? vehicleParts.find((el) => el.code === selectedElement)?.title
            : ""}
        </IonButton>
      </IonRow>

      <IonRow className="ion-justify-content-center">
        {/* <IonIcon
                  src={TractorLeftSvg}
                  className="ReportDamageModal-tractor  ion-justify-content-center"
                /> */}

        <div className="ReportDamageModal-zoomedcontainer">
          <ReactSVG
            className="ReportDamageModal-tractor_zoomed"
            src={currentSvg}
            beforeInjection={(svg) => {
              svg.style.width = "100%";
              svg.style.height = "10%";
              svg.style.maxHeight = "100px";
              svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
              svg.removeAttribute("width");
              svg.removeAttribute("height");
            }}
            afterInjection={(svg) => {
              const svgElement = svg as SVGSVGElement;

              if (
                side === "Inside" ||
                side === "TrailerInside" ||
                side === "Document"
              ) {
                let zoom = d3.zoom().on("zoom", (e) => {
                  d3.select(svgElement)
                    .select("g")
                    .attr("transform", e.transform);
                });
                d3.select(svgElement).call(zoom as any);
              } else {
                d3.select(svgElement).selectAll("g").attr("transform", null);

                try {
                  const bbox = svgElement.getBBox();
                  if (selectedElement) {
                    const selectedPaths = d3
                      .select(svgElement)
                      .selectAll("path")
                      .filter(function () {
                        const id = (this as any)?.id?.split("-")[0];
                        return id === "document";
                      });

                    if (selectedPaths.size() > 0) {
                      d3.select(svgElement)
                        .selectAll("path")
                        .style("opacity", "0.3");
                      selectedPaths.style("opacity", "1");

                      const pathBBox = (selectedPaths.node() as any)?.getBBox();

                      const topPadding = pathBBox.height * 0.25;
                      const bottomPadding = pathBBox.height * 0.5;
                      const sidePadding = pathBBox.width * 0.3;

                      const elementViewBox = `
                    ${pathBBox.x - sidePadding}
                    ${pathBBox.y - topPadding}
                    ${pathBBox.width + sidePadding * 2}
                    ${pathBBox.height + topPadding + bottomPadding}
                  `;
                      svgElement.setAttribute(
                        "viewBox",
                        elementViewBox.replace(/\s+/g, " ").trim()
                      );
                    }
                  } else {
                    const padding = Math.max(bbox.width, bbox.height) * 0.15;
                    const viewBox = `${bbox.x - padding} ${bbox.y - padding} ${
                      bbox.width + padding * 2
                    } ${bbox.height + padding * 2}`;
                    svgElement.setAttribute("viewBox", viewBox);
                  }
                } catch (e) {
                  console.error("Error setting viewBox:", e);
                }
                const zoom = d3
                  .zoom()
                  .scaleExtent([0.1, 10])
                  .on("zoom", (event) => {
                    d3.select(svgElement)
                      .select("g")
                      .attr("transform", event.transform);
                  });

                d3.select(svgElement).call(zoom as any);
              }
            }}
          />
        </div>
      </IonRow>

      <div className="ReportDamageModal-footer">
        <>
          <IonRow className="ReportDamageModal-step2-subtitle">
            Indiquez le type de dommage
          </IonRow>
          <IonRadioGroup
            className="ReportDamageModal-checkboxList"
            onIonChange={(e) => setSelectedElement(e.detail.value as string)}
            value={selectedElement}
          >
            {vehicleParts?.map((el) => (
              <div
                className={`ReportDamageModal-checkboxList-item ${
                  selectedElement === el.code
                    ? "ReportDamageModal-checkboxList-item_active"
                    : null
                }`}
              >
                {" "}
                <IonRadio
                  labelPlacement="end"
                  color={"primary"}
                  value={el.code}
                  key={el.code}
                >
                  {el.title}
                </IonRadio>
              </div>
            ))}
          </IonRadioGroup>
        </>

        <IonButton
          color={"success"}
          disabled={selectedElement ? false : true}
          expand="block"
          onClick={() => setStep(1)}
          className="ReportDamageModal-button_success"
        >
          Continuer
          <IonIcon icon={arrowForward} slot="end" />
        </IonButton>
      </div>
    </div>
  );
};

export default Step1Documents;
